import { formatISO, set } from "date-fns";
import { useSyncExternalStore } from "react";
import z from "zod";

const KEY = "calendarStartHour";

const dateSchema = z.coerce.date();

const DEFAULT = set(new Date(), {
  hours: 8,
  minutes: 0,
  seconds: 0,
  milliseconds: 0,
});

const subscribe = (callback: () => void) => {
  window.addEventListener("storage", callback);
  return () => window.removeEventListener("storage", callback);
};

const getSnapshot = () => {
  const item = localStorage.getItem(KEY);
  if (!item) return formatISO(DEFAULT);
  return item;
};

const setValue = (value: Date) => {
  localStorage.setItem(KEY, value.toISOString());
};

export const useCalendarStartTime = () => {
  const isoValue = useSyncExternalStore(subscribe, getSnapshot);

  const parseDate = (value: string) => {
    const parsed = dateSchema.safeParse(value);
    if (parsed.success) return parsed.data;
    return DEFAULT;
  };

  const value = parseDate(isoValue);

  return [value, setValue] as const;
};
